import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../../ui/dialog";

export function FullDisclaimerDialog({ open, onOpenChange, text }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg max-h-[85vh] overflow-y-auto" data-testid="ai-full-disclaimer-dialog">
        <DialogHeader>
          <DialogTitle>Full disclaimer</DialogTitle>
          <DialogDescription className="sr-only">AI Suggestions disclaimer</DialogDescription>
        </DialogHeader>
        <p className="text-xs leading-relaxed text-muted-foreground" data-testid="ai-full-disclaimer-text">{text}</p>
      </DialogContent>
    </Dialog>
  );
}

export function AiConsentDialog({ open, onOpenChange, text, onAgree, busy }) {
  const [read, setRead] = useState(false);
  const [data, setData] = useState(false);
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg max-h-[90vh] overflow-y-auto" data-testid="ai-consent-dialog">
        <DialogHeader>
          <DialogTitle className="font-serif text-2xl">Before you use AI Suggestions</DialogTitle>
          <DialogDescription className="text-xs">Please read this and tick both boxes.</DialogDescription>
        </DialogHeader>
        <div className="border hairline rounded p-3 text-xs leading-relaxed text-muted-foreground max-h-[38vh] overflow-y-auto" data-testid="ai-consent-text">
          {text}
        </div>
        <label className="flex items-start gap-2 text-xs cursor-pointer">
          <input type="checkbox" className="mt-0.5" checked={read} onChange={(e) => setRead(e.target.checked)} data-testid="ai-consent-read" />
          I have read and understood this disclaimer
        </label>
        <label className="flex items-start gap-2 text-xs cursor-pointer">
          <input type="checkbox" className="mt-0.5" checked={data} onChange={(e) => setData(e.target.checked)} data-testid="ai-consent-data" />
          I agree that my loan details (without my name, contact or account numbers) are processed by an AI service to generate suggestions.
        </label>
        <button type="button" disabled={!read || !data || busy} onClick={() => onAgree({ read, data })}
                className="btn-primary px-4 py-2 text-sm disabled:opacity-40 disabled:cursor-not-allowed" data-testid="ai-consent-agree">
          {busy ? "Saving…" : "Agree and continue"}
        </button>
      </DialogContent>
    </Dialog>
  );
}
